import React, { useMemo, useRef } from 'react';
import Button from '../Button';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import useImpressionCouponService from '../../../hooks/emarsys/coupon-service/useImpressionCouponService';
import eventClickCouponService from '../../../helpers/emarsys/coupon-service/eventClickCouponService';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import eventClickPackageService from '../../../helpers/emarsys/package-service/eventClickPackageService';
import useImpressionPackageService from '../../../hooks/emarsys/package-service/useImpressionPackageService';
import useImpressionAccessories from '../../../hooks/emarsys/accessories/useImpressionAccessories';
import eventClickAccessories from '../../../helpers/emarsys/accessories/eventClickAccessories';
import { truncateHtmlText } from '../../../helpers/utils/truncateHtmlString';

interface TermsConditionServicesProps {
  setShowTermsModalTnc: (value: boolean) => void;
  isCMS?: boolean;
  headingClassName?: string;
  termCondition?: any;
  showFullContent?: boolean;
  containerClassName?: string;
  contentClassName?: string;
  emarsysData?: {
    pageTitle: string;
    breadcrumbItems: IBreadcrumbs[];
    sku?: string;
    skuPrice?: string;
    carModel?: string[];
  };
  feature?: string;
}

const TermsConditionServices = ({
  setShowTermsModalTnc,
  isCMS = false,
  headingClassName,
  termCondition,
  showFullContent = false,
  containerClassName = '',
  contentClassName = '',
  emarsysData = {
    pageTitle: '',
    breadcrumbItems: [],
    sku: '',
    skuPrice: '',
    carModel: [],
  },
  feature = '',
}: TermsConditionServicesProps) => {
  const impressionRef = useRef(null);
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth) || {
    userData: null,
  };
  const { selectedCar, selectedPackage } = useSelector((state: any) => state.servicePackage) || {
    selectedCar: null,
    selectedPackage: null,
  };

  const handleShowTerms = (params: boolean) => {
    if (feature === 'COUPON_SERVICE') {
      eventClickCouponService(
        dispatch,
        selectedPackage,
        selectedCar,
        emarsysData.pageTitle,
        emarsysData.breadcrumbItems,
        userData?.customerNo,
        'cara pakai kupon servis',
        'lihat selengkapnya'
      );
    } else if (feature === 'PACKAGE_SERVICE') {
      eventClickPackageService(
        dispatch,
        selectedPackage,
        selectedCar,
        emarsysData.pageTitle,
        emarsysData.breadcrumbItems,
        userData?.customerNo,
        'cara pakai paket servis',
        'lihat selengkapnya'
      );
    } else if (feature === 'ACCESSORIES') {
      eventClickAccessories(
        dispatch,
        emarsysData.sku,
        emarsysData.skuPrice,
        emarsysData.pageTitle,
        emarsysData.breadcrumbItems,
        userData?.customerNo,
        'syarat & ketentuan',
        'lihat selengkapnya',
        emarsysData.carModel
      );
    }
    setShowTermsModalTnc(params);
  };

  const truncatedContent = useMemo(() => {
    return termCondition
      ? typeof window === 'undefined'
        ? termCondition?.termsAndConditionPage
        : `${truncateHtmlText(termCondition?.termsAndConditionPage, 150)}`
      : ''; // truncate to 150 content length
  }, [termCondition]);

  if (feature === 'COUPON_SERVICE') {
    useImpressionCouponService(
      impressionRef,
      emarsysData.pageTitle,
      emarsysData.breadcrumbItems,
      'syarat dan ketentuan kupon servis'
    );
  } else if (feature === 'PACKAGE_SERVICE') {
    useImpressionPackageService(
      impressionRef,
      emarsysData.pageTitle,
      emarsysData.breadcrumbItems,
      'syarat dan ketentuan paket servis'
    );
  } else if (feature === 'ACCESSORIES') {
    useImpressionAccessories(
      impressionRef,
      emarsysData.pageTitle,
      emarsysData.breadcrumbItems,
      emarsysData.sku,
      emarsysData.skuPrice,
      'syarat & ketentuan',
      emarsysData.carModel
    );
  }

  return (
    <>
      <section
        className={`w-full ${showFullContent ? 'overflow-auto lg:h-[calc(80vh*0.8)]' : ''} p-4 lg:container xl:px-0 ${containerClassName}`}
        ref={impressionRef}
      >
        {!showFullContent && (
          <h2
            className={`text-sm font-bold text-reliableBlack uppercase mb-2 lg:text-base ${headingClassName}`}
          >
            {termCondition?.termsAndConditionTitle}
          </h2>
        )}

        <div
          className={`prose prose-li:text-xs prose-p:text-xs lg:prose-li:text-sm lg:prose-p:text-sm  line-clamp-6 ${contentClassName}`}
          dangerouslySetInnerHTML={{
            __html: showFullContent ? termCondition?.termsAndConditionPage : truncatedContent,
          }}
        />

        {!showFullContent && typeof window !== 'undefined' && (
          <button
            className="inline-block text-xs font-medium text-hyperLink uppercase mt-2.5"
            onClick={isCMS ? () => {} : (e) => handleShowTerms(true)}
          >
            Lihat Selengkapnya
          </button>
        )}
      </section>
      {showFullContent && (
        <div className="w-full bg-white py-3 fixed bottom-0 lg:static px-4">
          <Button
            onClick={() => handleShowTerms(false)}
            variant="bg-supportiveRed"
            className="w-full h-[55px] rounded"
          >
            <span className="text-[#FFFFFF] text-base font-bold uppercase lg:text-sm">Setuju</span>
          </Button>
        </div>
      )}
    </>
  );
};

export default TermsConditionServices;
